
import { BiPlus } from "react-icons/bi";

export const QuestionFooterActions = ({ selectedTab, nextQuestionCallback, cancelCallback, saveCallback }) => {

    return (
        <div className='PS_Qus_Card_footer'>
            {/* <button className='btn btn-primary' onClick={() => nextQuestionCallback()}><BiPlus /> Next Question</button> */}
            <div>
                {/* <button className='btn btn-secondary px-3 me-2' onClick={() => cancelCallback()}>Cancel</button> */}
                <button className='btn btn-primary px-4 sbmBtn' onClick={() => saveCallback()}>Save</button>
            </div>
        </div>
    );
};

export default QuestionFooterActions;